const ISO_TIMESTAMP_WITH_OFFSET_REGEX =
  /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.\d+)?(Z|[+-]\d{2}:\d{2})?$/;

export const formatApiDateTime = (value, fallback = "-") => {
  if (!value) return fallback;

  const normalizedValue = String(value).trim();
  const timestampMatch = normalizedValue.match(ISO_TIMESTAMP_WITH_OFFSET_REGEX);

  // Preserve API wall-clock value exactly as sent, without local timezone conversion.
  if (timestampMatch) {
    const [, year, month, day, hours, minutes, seconds] = timestampMatch;
    return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds}`;
  }

  const date = new Date(normalizedValue);
  if (Number.isNaN(date.getTime())) return fallback;

  return date.toLocaleString();
};
